/**
 * The sidebar's sections, in the order SHL-1 sets: Today, Inbox, Shipped, People, Projects,
 * Milestones (MS-6), Reports, Trends, Talos. `matches` says which paths belong to a section, so a Person page lights up People.
 */
export const NAV_SECTIONS = [
  { key: 'today', label: 'Today', to: '/', matches: (path: string) => path === '/' || path.startsWith('/day/') },
  { key: 'inbox', label: 'Inbox', to: '/inbox', matches: (path: string) => path.startsWith('/inbox') },
  { key: 'shipped', label: 'Shipped', to: '/shipped', matches: (path: string) => path.startsWith('/shipped') },
  { key: 'people', label: 'People', to: '/people', matches: (path: string) => path.startsWith('/people') },
  { key: 'projects', label: 'Projects', to: '/projects', matches: (path: string) => path.startsWith('/projects') },
  { key: 'milestones', label: 'Milestones', to: '/milestones', matches: (path: string) => path.startsWith('/milestones') },
  { key: 'reports', label: 'Reports', to: '/reports', matches: (path: string) => path.startsWith('/reports') },
  { key: 'trends', label: 'Trends', to: '/trends', matches: (path: string) => path.startsWith('/trends') },
  { key: 'talos', label: 'Talos', to: '/talos', matches: (path: string) => path.startsWith('/talos') },
] as const;

export type NavSectionKey = (typeof NAV_SECTIONS)[number]['key'];
